import type React from 'react';
import { Label, Error, Icon, ClassHelper } from 'components/lib';
import { EMAIL_PATTERN } from '../../../services/inviteEmailValidation';
import Style from './input.tailwind.js';

interface EmailInputProps {
  errorMessage?: string;
  required?: boolean;
  onChange?: (name?: string, value?: string, valid?: boolean) => void;
  name?: string;
  className?: string;
  valid?: boolean;
  warning?: boolean;
  label?: string;
  type?: string;
  style?: React.CSSProperties;
  value?: string;
  placeholder?: string;
  validateOnBlur?: boolean;
}

export function EmailInput(props: EmailInputProps) {
  let error = props.errorMessage || 'Please enter a valid email address';

  function validate(e: React.FocusEvent<HTMLInputElement>) {
    let value = e ? e.target.value : '';
    let valid = undefined;

    // input is required and value is blank
    if (props.required && value === '') valid = false;

    // input isn't required and value is blank
    if (!props.required && value === '') valid = true;

    // now test for a valid email
    valid = EMAIL_PATTERN.test(value);

    // update the parent form
    props.onChange?.(props.name, value, valid);
  }

  // style
  const emailStyle = ClassHelper(Style, {
    textbox: true,
    className: props.className,
    error: props.valid === false,
    success: props.valid === true,
    warning: props.warning,
  });

  return (
    <div className={Style.input}>
      {props.label && <Label text={props.label} required={props.required} for={props.name} />}

      <input
        type={props.type}
        id={props.name}
        name={props.name}
        className={emailStyle}
        style={props.style}
        value={props.value || ''}
        placeholder={props.placeholder}
        onChange={(e) => props.onChange?.(props.name, e.target.value, undefined)}
        onBlur={props.validateOnBlur === false ? undefined : (e) => validate(e)}
      />

      {props.valid === false && <Error message={error} />}

      {props.valid === true && <Icon image="check" color="#8CC57D" className={Style.successIcon} size={16} />}
    </div>
  );
}
